import AlignTopIcon from "@/components/icons/AlignTopIcon.vue";
import StrokedCopyIcon from "@/components/icons/StrokedCopyIcon.vue";
import LayersTwoDashedIcon from "./icons/LayersTwoDashedIcon.vue";
import LayersTwoIcon from "./icons/LayersTwoIcon.vue";
import AppDropdown from "@/components/AppDropdown.vue";
export default {
  name: "EvolutionChartExportOption",
  props: {
    title: String
  },
  emits: ['copy', 'copy-no-background'],
  components: {
    AlignTopIcon,
    StrokedCopyIcon,
    LayersTwoDashedIcon,
    LayersTwoIcon,
    AppDropdown
  }
};